function parseBoolean(value, fallback = false) {
  const normalizedValue = String(value ?? "").trim().toLowerCase();

  if (["true", "1", "yes", "on"].includes(normalizedValue)) {
    return true;
  }

  if (["false", "0", "no", "off"].includes(normalizedValue)) {
    return false;
  }

  return fallback;
}

function normalizeAdSenseClient(value) {
  const normalizedValue = String(value ?? "").trim();

  if (!normalizedValue) {
    return "";
  }

  return normalizedValue.startsWith("ca-") ? normalizedValue : `ca-${normalizedValue}`;
}

export const ADMIN_USERNAME_HINT = String(process.env.REACT_APP_ADMIN_USERNAME_HINT || "admin").trim() || "admin";
export const ADMIN_PASSWORD_HINT = String(process.env.REACT_APP_ADMIN_PASSWORD_HINT || "").trim();
export const SHOW_ADMIN_HINT = parseBoolean(process.env.REACT_APP_SHOW_ADMIN_HINT, false);
export const ADSENSE_CLIENT = normalizeAdSenseClient(process.env.REACT_APP_ADSENSE_CLIENT);
export const ADSENSE_ENABLED = parseBoolean(process.env.REACT_APP_ADSENSE_ENABLED, false) && Boolean(ADSENSE_CLIENT);
export const ADSENSE_HOME_SLOT = String(process.env.REACT_APP_ADSENSE_HOME_SLOT || "").trim();